import type { RouteRecordRaw } from "vue-router";

const router: RouteRecordRaw[] = [
  {
    path: "/data/import/",
    name: "LISADataImport",
    children: [
      {
        path: "",
        name: "LISADataImportList",
        component: () => import("./views/LISAImportList.vue"),
        meta: {
          rights: ["systemSettings.admin"],
        },
      },
      {
        path: "create",
        name: "LISADataImportCreate",
        component: () => import("./views/LISAImportCreate.vue"),
        props: (route) => {
          const queryValue = Array.isArray(route.query.siteId)
            ? route.query.siteId[0]
            : route.query.siteId;
          const siteId = queryValue == null ? undefined : Number(queryValue);
          return {
            siteId: Number.isInteger(siteId) ? siteId : undefined,
          };
        },
        meta: {
          rights: ["systemSettings.admin"],
        },
      },
      {
        path: ":id",
        name: "LISADataImportUpdate",
        component: () => import("./views/LISAImportUpdate.vue"),
        props: (p) => ({ id: Number(p.params.id) }),
        meta: {
          rights: ["systemSettings.admin"],
        },
      },
    ],
  },
];
export default router;
